var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-page-layout',{attrs:{"title":"Gerais"}},[_c('v-container',{staticClass:"compartilhamento px-0",attrs:{"fluid":""}},[(_vm.$getAllowedModules()['points'])?_c('points-configuration'):_vm._e(),_c('contacts-table')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }